import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/retos/provincias")({
  head: () => ({
    meta: [
      { title: "Explora por provincia — Watts" },
      { name: "description", content: "Descubre los puertos de Catalunya por provincia." },
      { property: "og:title", content: "Explora por provincia — Watts" },
      { property: "og:description", content: "Descubre los puertos de Catalunya por provincia." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: Provincias,
});

const PROVINCIAS = ["Barcelona", "Girona", "Lleida", "Tarragona"];

function Provincias() {
  return (
    <div className="h-screen overflow-y-auto bg-background fade-in">
      <header className="flex items-center gap-3 px-5 pt-[max(env(safe-area-inset-top),1rem)] pb-4">
        <Link to="/retos" className="press-scale flex h-10 w-10 items-center justify-center rounded-full bg-surface text-foreground">
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <h1 className="font-display text-2xl text-foreground">Explora por provincia</h1>
      </header>

      <main className="grid gap-3 px-4 py-2">
        {PROVINCIAS.map((prov) => (
          <div
            key={prov}
            className="flex items-center justify-between rounded-2xl border border-border bg-surface p-4"
          >
            <span className="font-display text-lg text-foreground">{prov}</span>
            <span className="text-xs text-muted-foreground">Próximamente</span>
          </div>
        ))}
      </main>
    </div>
  );
}
